<template>
<!-- 数字滚动 -->
  <div class="container achievement">
    <div class="number-header flex-align-center flex-center">
      <div class="renderg mr5">
        <img src="../../assets/image/achievement.png" alt="">
      </div>
      <h2 class="title">专业云渲染平台</h2>
    </div>
    <div class="count-list number-box">
      <el-row class="number-content">
        <el-col class="number-item" :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <p class="number-grow">
            <NumberGrow :value="'10'"></NumberGrow><strong>K</strong>
            <em>+</em>
          </p>
          <p class="achiev-name">CPU</p>
        </el-col>
        <el-col class="number-item" :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <p class="number-grow">
            <NumberGrow :value="'10'"></NumberGrow><strong>K</strong>
            <em>+</em>
          </p>
          <p class="achiev-name">GPU</p>
        </el-col>
        <el-col class="number-item" :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <p class="number-grow">
            <NumberGrow :value="'100'"></NumberGrow><strong>W</strong>
            <em>+</em>
          </p>
          <p class="achiev-name">JOB</p>
        </el-col>
      </el-row>
      <p class="number-footer">顶尖云渲染服务供应商之一，已服务客户10000 +</p>
    </div>
  </div>
</template>

<script>
import NumberGrow from '../numbergrow/index'
export default {
  components: {
    NumberGrow
  }
}
</script>